import React, { useEffect } from 'react';
import Hero from './components/Hero';
import Challenge from './components/Challenge';
import WhatToExpect from './components/WhatToExpect';
import PreviousDialogues from './components/PreviousDialogues';
import LinkedInPosts from './components/LinkedInPosts';
import UpcomingEvents from './components/UpcomingEvents';
import WhoShouldAttend from './components/WhoShouldAttend';
import CompanyLogos from './components/CompanyLogos';
// import Testimonials from './components/Testimonials';
import RequestInvitation from './components/RequestInvitation';
import AboutEnculture from './components/AboutEnculture';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Handle hash routing on initial page load
    const handleHashScroll = () => {
      const hash = window.location.hash;
      if (hash) {
        // Remove the # symbol
        const id = hash.substring(1);
        // Wait for page to render, then scroll
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            // Scroll to the top of the element with no offset to avoid white space
            window.scrollTo({
              top: element.offsetTop,
              behavior: 'smooth'
            });
          }
        }, 300);
      }
    };

    // Run on mount
    handleHashScroll();

    // Also listen for hash changes
    window.addEventListener('hashchange', handleHashScroll);

    return () => {
      window.removeEventListener('hashchange', handleHashScroll);
    };
  }, []);

  return (
    <div className="App font-body">
      <Hero />
      <Challenge />
      <WhatToExpect />
      <PreviousDialogues />
      <LinkedInPosts />
      <UpcomingEvents />
      <WhoShouldAttend />
      <CompanyLogos />
      {/* <Testimonials /> */}
      <RequestInvitation />
      <AboutEnculture />
      <Footer />
    </div>
  );
}

// Error boundary for debugging
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    console.error('Global error:', e.error);
  });
  window.addEventListener('unhandledrejection', (e) => {
    console.error('Unhandled promise rejection:', e.reason);
  });
}

export default App;

